export default window.yxpapi;
